var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61581 21.9892H19.9785C21.3022 21.9892 22.1057 21.3816 22.1057 20.3992C22.1057 17.2363 17.9629 12.8712 11.2997 12.8712C4.64799 12.8712 0.5 17.2363 0.5 20.3992C0.5 21.3816 1.30857 21.9892 2.61581 21.9892ZM11.3099 10.6716C14.0907 10.6716 16.4308 8.32384 16.4308 5.26469C16.4308 2.27954 14.0754 0 11.3099 0C8.55577 0 6.19529 2.32281 6.19529 5.28633C6.19529 8.32384 8.54048 10.6716 11.3099 10.6716Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.95c5c7ed5b2244b3748a4f23fcb5243f.svg";
export { ForwardRef as ReactComponent };